import { pick, groupBy, forEach, get, orderBy, map } from '@dt/fe-utils/dist/lodash'
import { format, toDecimal, ddayjs } from '@dt/fe-utils'
import { getModifierStrAndModifierPrice } from './cookware'
import OrderAPI from 'api/order.api'

/**
  managerItemDiscount: 手动店长单品折扣
  managerItemAndModifierDiscount: 手动店长单品+加料折扣
  memberCardDiscount: 会员折扣
  itemCoupon: 单品券
  managerDiscount: 手动店长折扣
  automaticDiscount: 自动整单优惠
  automaticItemDiscount: 自动单品优惠
  automaticDiscountPromoCode: 自动优惠码整单优惠
  automaticItemDiscountPromoCode: 自动优惠码单品优惠
  orderCoupon: 整单优惠券
  cashCoupon: 现金券
  floorDiscount: 整单抹零
  integralMoney: 积分抵现
  memberPrice: 会员价
  nthItemNDiscount: 第N杯N价(第二杯半价) （餐品级）
  designatedItemDiscount: 指定满减 （订单级）
  nthItemNDiscountPromoCode: 第N杯N价 优惠码
  designatedItemDiscountPromoCode: 指定满减 优惠码
  meituan / eleme
  orderSwapBuy: 整单换购活动
  singleItemSwapBuy: 单品换购活动
  fullItemNFree: 单品满送
*/

const ITEM_DISCOUNT_TYPE = ['managerItemDiscount', 'managerItemAndModifierDiscount', 'automaticItemDiscount', 'memberCardDiscount', 'itemCoupon', 'memberPrice', 'nthItemNDiscount', 'singleItemSwapBuy', 'orderSwapBuy', 'fullItemNFree']

// 计算viewDetailList
function computedViewDetailList (viewDetailList: any, managerDiscountMap: { [detailId: string]: any }, modifierDetailId2Mkt: { [detailId: string]: any }, modifierPk2Mkt: any = {}, pk2Mkt: any = {}, channel: TChannel, singleDiscountMap: { [detailId: string]: any }) {
  return viewDetailList.map((detail: any) => {
    let apportionOffPrice = 0
    let singleOffPrice = 0
    let { modifierStr, modifierHtml, modifierPrice } = getModifierStrAndModifierPrice(detail.modifierGroups)
    let modifierTax = 0
    let modifierFreeTax = 0
    detail.modifierGroups.forEach((modifierGroup: IDoModifierGroup) => {
      modifierGroup.modifiers.forEach(item => {
        modifierTax += item.tax || 0
        modifierFreeTax += item.freeTax || 0
        if (item.detailId && managerDiscountMap[item.detailId]) {
          apportionOffPrice += managerDiscountMap[item.detailId]
        }
        if (item.detailId && modifierDetailId2Mkt[item.detailId]) {
          // 将加料的优惠的金额合并到主餐品中
          modifierPk2Mkt[detail.pk] = [...(modifierPk2Mkt[detail.pk] || []), ...modifierDetailId2Mkt[item.detailId]]
        }
      })
    })
    let optionStr = modifierStr
    let optionHtml = modifierHtml
    if (detail.scaleName) {
      optionStr = modifierStr && detail.scaleName ? [detail.scaleName, modifierStr].join(', ') : detail.scaleName || modifierStr
      optionHtml = modifierHtml && detail.scaleName ? modifierHtml.replace('<span>', '<span>' + detail.scaleName + ', ') : modifierHtml || `<span>${detail.scaleName}</span>`
    }
    // 当前整单级的优惠平摊到餐品上，分成2部分，一部分是店长折扣的，一部分是整单优惠的（暂不用考虑），店长折扣会平摊到每个加料上
    if (managerDiscountMap[detail.detailId]) {
      apportionOffPrice += managerDiscountMap[detail.detailId]
    }
    // 单品折扣
    if (singleDiscountMap[detail.detailId]) {
      singleOffPrice += singleDiscountMap[detail.detailId]
    }
    const totalProductPrice = detail.totalProductPrice
    const productCnt = detail.cnt === 0 ? detail.originalCnt : detail.cnt
    const productPrice = productCnt ? toDecimal(totalProductPrice / productCnt) : 0
    // 餐品实收的税 并且是保留7位精度的
    const tax = detail.tax
    const freeTax = detail.freeTax
    const totalTax = toDecimal(detail.tax + modifierTax, 7)
    const totalFreeTax = toDecimal(freeTax + modifierFreeTax, 7)
    const unitPrice = modifierPrice + productPrice
    const unitTax = detail.cnt ? toDecimal(totalTax / detail.cnt, 7) : 0
    const unitPriceWithTax = toDecimal(unitPrice + unitTax, 7)
    const unitBoxPrice = toDecimal(detail.unitBoxPrice, 7)
    let totalPrice = unitPrice * productCnt
    const totalPriceWithTax = toDecimal(totalPrice + totalTax, 7)
    const totalBoxPrice = toDecimal(detail.totalBoxPrice, 7)
    // 优惠
    const offItems: any[] = []
    let offPrice = 0
    let isOrderSwapBuy = false
    let isFullItemNFree = false
    if (pk2Mkt[detail.pk]) {
      pk2Mkt[detail.pk].forEach((discount: any) => {
        const liteDiscountType = discount.discountType.replace('PromoCode', '')
        if (channel === 'buyTogether') {
          offItems.push({
            off: discount.fee,
            offTip: discount.discountName,
            offType: discount.discountType
          })
          offPrice += discount.fee
        } else {
          if (ITEM_DISCOUNT_TYPE.includes(liteDiscountType)) {
            let discountValue = 0
            let isRateDiscount = false
            if (discount.activityType === 'discountRate') {
              isRateDiscount = true
            }
            try {
              discountValue = JSON.parse(discount.activityContent || '{}')?.discountValue || 0
            } catch (err) {

            }
            offItems.push({
              off: discount.fee,
              offTip: discount.discountName,
              offType: discount.discountType,
              discountValue,
              isRateDiscount
            })
            offPrice += discount.fee
            if (liteDiscountType === 'fullItemNFree') {
              /** 满送信息会被营销清空 */
              isFullItemNFree = true
            }
            if (liteDiscountType === 'orderSwapBuy') {
              isOrderSwapBuy = true
            }
          }
        }
      })
    }
    // 套餐
    const productGroups = detail.productGroups?.length ? detail.productGroups?.map((group: any) => {
      group.productGroupDetails = computedViewDetailList(group.productGroupDetails, managerDiscountMap, modifierDetailId2Mkt, modifierPk2Mkt, pk2Mkt, channel, singleDiscountMap)
      return group
    }) : detail.productGroups
    if (productGroups?.length) {
      productGroups?.forEach((group: any) => {
        group.productGroupDetails.forEach((product: any) => {
          // 套餐加料价格(餐品合计)
          modifierPrice += (product.modifierPrice || 0) * detail.cnt * product.cnt
          // 整单加料优惠
          apportionOffPrice += group.productGroupDetails.reduce((p: number, s: any) => {
            return p + (managerDiscountMap[s.detailId] || 0)
          }, 0)
          // 加料优惠
          product.modifierGroups.forEach((modifierGroup: IDoModifierGroup) => {
            modifierGroup.modifiers.forEach(item => {
              if (item.detailId && managerDiscountMap[item.detailId]) {
                apportionOffPrice += managerDiscountMap[item.detailId]
              }
              if (item.detailId && modifierDetailId2Mkt[item.detailId]) {
                modifierPk2Mkt[detail.pk] = [...(modifierPk2Mkt[detail.pk] || []), ...modifierDetailId2Mkt[item.detailId]]
              }
            })
          })
        })
      })
      modifierPrice = toDecimal(modifierPrice)
      totalPrice = toDecimal(totalPrice + modifierPrice)
    }
    if (modifierPk2Mkt[detail.pk]) {
      modifierPk2Mkt[detail.pk].forEach((modifierDiscount: any) => {
        const theProductDiscount = offItems.find(off => off.offTip === modifierDiscount.discountName && off.offType === modifierDiscount.discountType)
        if (theProductDiscount) {
          theProductDiscount.off += modifierDiscount.fee
          offPrice += modifierDiscount.fee
        }
      })
    }
    if (detail.ordersHuangou) {
      isOrderSwapBuy = true
    }
    offPrice = toDecimal(offPrice)
    const actualPrice = toDecimal(totalPrice - offPrice)
    const totalActualPrice = actualPrice
    const realPrice = toDecimal(actualPrice - apportionOffPrice)
    const unitRealPrice = detail.cnt ? toDecimal(realPrice / detail.cnt) : 0
    const unitRealPriceWithTax = toDecimal(unitRealPrice + unitTax, 7)
    const realPriceWithTax = toDecimal(realPrice + totalTax, 7)
    const isWait = detail.status === 'NotAccepted'
    // TODO 当前类型限制丢失
    const theDetail: IViewOrderDetail = {
      ...pick(detail, ['cnt', 'yuYue', 'productExt', 'pic', 'deliveryTime', 'productGroupNo', 'parentId', 'detailId', 'categoryName', 'categoryNo', 'name', 'productNo', 'scaleName', 'scaleNo', 'remark', 'isTogo', 'pk', 'fkey', 'modifierGroups', 'refundCnt', 'originalCnt', 'startTime', 'pickTimeRange', 'startTimeOffset', 'startTimeStamp', 'addTimeStamp', 'statisticsCategoryNo', 'addTime', 'addUserId', 'addUserName', 'addUserAvatar', 'taxCategoryId', 'showTax', 'isAddProduct', 'kitchenPrintTime', 'kitchenPrintTimeStamp', 'currentStatusIndex', 'seat', 'addPrice', 'channel']),
      type: detail.type,
      modifierStr,
      modifierHtml,
      optionStr,
      optionHtml,
      // price,
      productPrice,
      modifierPrice,
      unitPrice,
      tax,
      freeTax,
      isTaxFree: !!freeTax,
      unitTax,
      unitPriceWithTax,
      unitBoxPrice,
      totalTax,
      totalFreeTax,
      totalBoxPrice,
      totalPrice: isNaN(totalPrice) ? 0 : totalPrice,
      totalPriceWithTax,
      offPrice: toDecimal(offPrice),
      offItems,
      totalProductPrice,
      actualPrice,
      totalActualPrice,
      realPrice,
      unitRealPrice,
      unitRealPriceWithTax,
      realPriceWithTax,
      apportionOffPrice,
      singleOffPrice,
      allergys: [],
      tags: [],
      isWait,
      productGroups,
      isOrderSwapBuy,
      isFullItemNFree
    }
    return theDetail
  }) as IViewOrderDetail[]
}

class OrderFactory {
  data = {}
  constructor (orderData: any) {
    this.data = orderData
  }
  static async create (ordersId: string, config?: {
    member?: boolean;
    isNoToken?: boolean;
    deliveryAndInvoice?: boolean;
    showOrderCart?: boolean;
    fromGoldPlan?: boolean;
    brandId?: number;
    memberId?: number;
    showPingtanByMember?: 0 | 1;
    showMember?: 0 | 1;
    showMktProducts?: 0 | 1;
    isCancel?: boolean;
    showOrdersLog?: 0 | 1;
  }) {
    return this.getOrder(ordersId, {
      member: !!config?.member,
      isNoToken: !!config?.isNoToken,
      deliveryAndInvoice: !!config?.deliveryAndInvoice,
      showOrderCart: !!config?.showOrderCart,
      fromGoldPlan: config?.fromGoldPlan,
      brandId: config?.brandId,
      memberId: config?.memberId,
      showKds: 1,
      showPingtanByMember: config?.showPingtanByMember || 0,
      showMember: config?.showMember,
      showMktProducts: config?.showMktProducts,
      isCancel: config?.isCancel,
      showOrdersLog: config?.showOrdersLog || 0
    }).then((data: any) => {
      return new OrderFactory(data.result)
    }, (err) => {
      throw err
    })
  }
  static createPreOrderData (ordersData: any) {
    return new OrderFactory(ordersData)
  }
  /** 返回一个计算后的order */
  static async make (ordersId: string) {
    return this.getOrder(ordersId).then((data: any) => {
      return Object.assign(this.convertOrder(data.result), {
        detail: this.convertDetail(data.result)
      }) as IViewOrder
    })
  }
  // static convert ({ viewCartItems, info, cartResult }: {viewCartItems: IViewCartItem[]; info: ICartInfo; cartResult: ICartResult}) {
  //   const orderData = convertCartDataToOrderData({ viewCartItems, info, cartResult })
  //   return new OrderFactory(orderData)
  // }
  static async getOrder (ordersId: string, moreInfo?: {
    member: boolean;
    isNoToken: boolean;
    deliveryAndInvoice: boolean;
    showOrderCart: boolean;
    fromGoldPlan?: boolean;
    brandId?: number;
    memberId?: number;
    showKds: 0 | 1;
    showPingtanByMember: 0 | 1;
    showMember?: 0 | 1;
    showMktProducts?: 0 | 1;
    showOrdersLog?: 0 | 1;
    isCancel?: boolean;
  }) {
    if (!ordersId) {
      const data = { error: true, message: '订单不存在了' }
      throw data
    }
    return OrderAPI.get(ordersId, moreInfo).then((data: any) => {
      if (data && data.result) {
        return data
      }
      throw data
    })
  }
  /** 用于转换关系的通用的转换方法，即用于orderMobx 用于实时计算，又用于流转，用于订单转换 */
  static convertOrder (order: IOrder) {
    // 分离出服务费 小费 和 税 同时计算优惠价格
    let serviceCharge = 0
    let serviceChargeDetailId = ''
    let serviceChargeGratuityName = ''
    let expressPrice = 0
    let expressItem: IOrderDetail[] = []

    let itemPrice = 0
    let thirdOffPrice = 0
    let boxPrice = 0
    order.detailList.forEach(detail => {
      if (detail.itemType === 'serviceCharge') {
        serviceCharge += detail.originalFee
        serviceChargeDetailId = detail.detailId
        serviceChargeGratuityName = detail.productScaleName
      } else if (detail.itemType === 'express') {
        expressPrice += detail.originalFee
        expressItem.push(detail)
        // 2023.11.20 rollback expressPrice += detail.originalFee
        // 拼单情况下 会有多笔配送费 由同一个originalFee分摊成多个paidFee
        // expressPrice += detail.paidFee
      } else if (detail.itemType === 'box') {
        boxPrice += detail.originalFee
      } else if (detail.itemType === 'modifier' || detail.itemType === 'product' || detail.itemType === 'mallProduct') {
        itemPrice += detail.originalFee
      } else if (['memberCardRenew', 'memberCardBuy', 'memberCz', 'giftcardCz'].includes(detail.itemType)) {
        itemPrice += detail.originalFee
      }
    })
    // const tipItem = order.detailList.find(detail => detail.itemType === 'tip' && detail.paidFee > 0)
    // const tip = tipItem?.paidFee || 0
    const tip = order.tip
    let totalDiscountPrice = 0
    // let managerDiscount = 0
    let discountItemPrice = 0
    let discountWholePrice = 0
    let discountPlanPrice = 0
    let discountActivityPrice = 0
    const offItems: any[] = []
    const offMap: any = {}
    let planReason: string = ''
    let planTagId = 0
    let discountValue = 0
    let isRateDiscount = false
    let floorReason: string = ''
    let integralMoneyReason: string = ''
    let promoCodeReason: string = ''
    let discountItemCouponPrice = 0
    let discountPromoCodeWholePrice = 0
    let discountPromoCodeItemPrice = 0
    if (order.discountList) {
      order.discountList.forEach((discount: any) => {
        if (discount.fee) {
          totalDiscountPrice += discount.fee
          // discountType: "managerItemDiscount"
          // TODO: 暂时把会员价归到餐品优惠中
          const isPromoCode = discount.discountType.endsWith('PromoCode')
          const liteDiscountType = isPromoCode ? discount.discountType.replace('PromoCode', '') : discount.discountType
          // 餐品级优惠
          if (ITEM_DISCOUNT_TYPE.includes(liteDiscountType)) {
            discountItemPrice += discount.fee
            if (liteDiscountType === 'itemCoupon') {
              discountItemCouponPrice += discount.fee
            }
            if (isPromoCode) {
              discountPromoCodeItemPrice += discount.fee
            }
            // 三方优惠
          } else if (liteDiscountType === 'meituan' || liteDiscountType === 'eleme') {
            thirdOffPrice += discount.fee
            // 订单级优惠
          } else {
            offMap[discount.discountName] = offMap[discount.discountName] ? offMap[discount.discountName] + discount.fee : discount.fee
            discountWholePrice += discount.fee
            if (liteDiscountType === 'automaticDiscount') {
              discountActivityPrice += discount.fee
            }
            if (liteDiscountType === 'managerDiscount') {
              discountPlanPrice += discount.fee
              planReason = discount.discountName
              planTagId = discount.discountTypeName ? parseInt(discount.discountTypeName) : 0
              if (discount.activityType === 'discountRate') {
                isRateDiscount = true
                discountValue = 0
                try {
                  discountValue = JSON.parse(discount?.activityContent || '{}')?.discountValue || 0
                } catch (err) {

                }
              }
            }
            if (liteDiscountType === 'floorDiscount') {
              floorReason = discount.discountName
            }
            if (liteDiscountType === 'integralMoney') {
              integralMoneyReason = discount.discountName
            }
            if (isPromoCode) {
              discountPromoCodeWholePrice += discount.fee
            }
            // 210315 将不再独立显示优惠码活动
            // if (discount.discountType === 'promoCode') {
            //   promoCodeReason = discount.discountName
            // }
          }
        }
      })
    }

    // 抹零和积分抵现和手工折扣不再放到整单的优惠列表中 展示中需要独立处理
    forEach(offMap, (value, key) => {
      if (key !== planReason && key !== floorReason && key !== integralMoneyReason && key !== promoCodeReason) {
        offItems.push({
          off: value,
          offTip: key
        })
      }
    })

    const orderPlanOffItem = planReason ? {
      off: offMap[planReason],
      offTip: planReason,
      tagId: planTagId,
      isRateDiscount,
      discountValue
    } : undefined

    const floorOffItem = floorReason ? {
      off: offMap[floorReason],
      offTip: floorReason
    } : undefined

    const integralMoneyOffItem = integralMoneyReason ? {
      off: offMap[integralMoneyReason],
      offTip: integralMoneyReason
    } : undefined

    const discountFloorPrice = floorOffItem ? floorOffItem.off : 0
    const discountIntegralMoneyPrice = integralMoneyOffItem ? integralMoneyOffItem.off : 0
    // const discountPromoCodeWholePrice = promoCodeOffItem ? promoCodeOffItem.off : 0
    // 处理附加费
    let surcharge: number = 0
    const surchargeItems: any[] = []
    forEach(order.detailList, (detailItem: any) => {
      if (detailItem.itemType === 'surcharge') {
        surcharge += detailItem.paidFee
        surchargeItems.push({
          name: detailItem.productName,
          rate: detailItem.productScaleName,
          fee: detailItem.paidFee
        })
      }
    })
    const totalPrice = toDecimal(order.paidFee + order.tax) // 总计
    // order.paymentList
    const change = (order.paymentList?.length === 1 && order.paymentList[0].channelType.Cash?.ext?.change) || (Array.isArray(order.paymentList) && order.paymentList.length > 1 && order.paymentList[order.paymentList.length - 1].channelType.Cash?.ext?.change) || '0'
    let contactAddress: any
    let contactApt: any
    // contact 联系人
    if (order.contactInfo) {
      try {
        const contactInfo = JSON.parse(order.contactInfo)
        contactAddress = contactInfo.address || ''
        contactApt = contactInfo.apt || ''
      } catch (err) {
        console.error(err)
      }
    }

    const tax = order.tax
    const freeTax = order.freeTax || 0
    const itemActualPrice = toDecimal(itemPrice - discountItemPrice - order.showTax)
    const itemTotalPrice = toDecimal(itemPrice - totalDiscountPrice - order.showTax)
    const totalPriceExcludeTip = toDecimal(totalPrice - tip)
    const totalOriginalPrice = toDecimal(order.paidFee + totalDiscountPrice)
    const discountCouponPrice = 0

    /** 拆分开票信息和配送状态 */
    const invoiced = !!order.deliverInfo?.invoiced
    const taxpayerId = order.deliverInfo?.taxpayerId || ''
    const invoiceTitle = order.deliverInfo?.invoiceTitle || ''
    const getExpressList = (orderDeliverInfo?: any, orderExpressList?: any[]) => {
      const deliverInfo = orderDeliverInfo?.deliverys?.length ? orderDeliverInfo : orderExpressList?.[0] || orderDeliverInfo
      const recentlyDelivery = get(deliverInfo?.deliverys, '0') || {}
      const deliveryEventCode = recentlyDelivery?.eventCode
      const deliveryType = !deliverInfo?.deliveryType ? (order.channel as any)
        : deliverInfo?.deliveryType === 'default' ? (deliverInfo?.channel || order.channel) : deliverInfo?.deliveryType || ''
      const eventMeaning = recentlyDelivery?.eventMeaning
      const deliveryTypes = recentlyDelivery?.deliveryTypes
      let deliveryStatus = 'awaitSend'
      switch (deliveryEventCode) {
        // 发单失败 => 走重新发单
        case 'orderDelivery.deliveryOrderCreateFail':
          deliveryStatus = 'awaitSend'
          break
        // 等待派单
        case 'orderDelivery.awaitDelivery':
          deliveryStatus = 'awaitAccept'
          break
        // 已接单 骑手到店
        case 'orderDelivery.awaitPickUp':
        case 'orderDelivery.diliverymanArrive':
        case 'orderDelivery.riderTransfer':
          deliveryStatus = 'isAccept'
          break
        // 骑手已取餐
        case 'orderDelivery.diliverymanPickUp':
          deliveryStatus = 'isDelivery'
          break
        // 配送成功
        case 'orderDelivery.deliverySuccess':
          deliveryStatus = 'isDeliverySuccess'
          break
        // 配送取消
        case 'orderDelivery.deliveryCancel':
          deliveryStatus = 'isDeliveryCancel'
          break
        case 'orderDelivery.deliveryFailed':
          deliveryStatus = 'isDeliveryFailed'
          break
        default:
          break
      }
      return {
        deliveryType,
        deliverInfo,
        deliverySetting: deliverInfo?.deliverySetting,
        deliveryEventCode,
        status: deliveryStatus,
        statusText: eventMeaning,
        pushTime: deliverInfo?.pushTime,
        sendTime: deliverInfo?.deliverys?.find((i: any) => i.eventCode === 'orderDelivery.awaitDelivery')?.addTime,
        acceptTime: deliverInfo?.deliverys?.find((i: any) => i.eventCode === 'orderDelivery.awaitPickUp')?.addTime,
        completeTime: deliverInfo?.deliverys?.find((i: any) => ['orderDelivery.deliverySuccess', 'orderDelivery.deliveryFailed', 'orderDelivery.deliveryCancel'].includes(i.eventCode))?.addTime,
        diliveryManInfo: {
          courierName: recentlyDelivery?.courierName,
          courierMobile: recentlyDelivery?.courierMobile
        },
        customerMobile: order.contactMobile || deliverInfo?.customerMobile,
        customerName: order.contactName || deliverInfo?.customerName,
        customerAddress: contactAddress,
        isStartDeliver: !!deliverInfo?.deliverys?.length,
        deliveryOrdersId: deliverInfo?.ordersId,
        deliveryTime: deliverInfo?.deliveryTime,
        deliveryTip: deliverInfo?.deliveryTip,
        deliveryTipCnt: deliverInfo?.deliveryTipCnt,
        deliveryTypes,
      }
    }

    // 订单的状态
    const status = order.paymentList && order.paymentList.length && order.status === 'Pending' ? 'Paying' : order.status

    const isWait = status === 'NotAccepted'
    /** TODO: 暂时在这里计算服务费转换 */
    const serviceChargeDetail: ICalculatedServiceCharge[] = order.detailList.filter(item => item.itemType === 'serviceCharge').map(item => {
      return {
        id: item.id,
        name: item.productName,
        /** 不知道什么意思 */
        discounted: '',
        diningOption: '',
        type: item.productCategoryName as 'person' | 'amount' | 'percent',
        /** 人数计算条件 */
        applyRange: 1,
        /** 计算条件的值 */
        value: Number(item.productCategoryNo) || 0,
        /** 服务费计算的结果 */
        amount: item.paidFee,
        /** 服务费含税 */
        tax: {
          name: '',
          category: '',
          rate: 0,
          amount: 0,
        }
      }
    })

    //  处理税的detail
    const taxDetailMap: Map<number, {
      taxCategoryId: number;
      name: string;
      rate: number | undefined;
      amount: number;
      isTaxFree: boolean;
    }> = new Map()
    let freeTaxCategoryList = order.extList?.find(list => list.attrName === 'freeTaxCategoryList')?.attrValue || '[]'
    try {
      freeTaxCategoryList = JSON.parse(freeTaxCategoryList)
    } catch (err) { }
    order.detailList.forEach(detail => {
      if (detail.taxList && detail.taxList.length) {
        const taxItem = detail.taxList.find(taxItem => taxItem.status !== 'Closed')
        if (taxItem) {
          const etaxDetail = taxDetailMap.get(taxItem.productTaxCategoryId)
          if (etaxDetail) {
            taxDetailMap.set(taxItem.productTaxCategoryId, {
              ...etaxDetail,
              amount: toDecimal(etaxDetail.amount + taxItem.tax)
            })
          } else {
            taxDetailMap.set(taxItem.productTaxCategoryId, {
              taxCategoryId: taxItem.productTaxCategoryId,
              name: taxItem.taxName,
              rate: taxItem.taxRate || 0,
              amount: taxItem.tax,
              isTaxFree: !!freeTaxCategoryList.includes(taxItem.productTaxCategoryId + '')
            })
          }
        }
      }
    })
    if (order.channel === 'deliverect') {
      taxDetailMap.set(-9999, {
        taxCategoryId: -9999,
        name: '',
        rate: undefined,
        amount: order.tax,
        isTaxFree: false
      })
    }
    const taxDetail = Array.from(taxDetailMap.values())
    const isMeituanOrEleme = order.sourceType === 'meituan' || order.sourceType === 'eleme' || order.sourceType === 'douyin'
    const isCreditCardFirst = !!(order.extList && order.extList.find(ext => ext.attrName === 'prePayType'))
    const scanType = order.extList?.find(ext => ext.attrName === 'scanType')?.attrValue
    const posMember = {
      memberId: order.extList?.find(ext => ext.attrName === 'posMemberId')?.attrValue || '0',
      memberGroupId: order.extList?.find(ext => ext.attrName === 'posMemberGroupId')?.attrValue || '0'
    }
    return {
      ...order,
      deliveryDetail: getExpressList(order.deliverInfo, order.expressList),
      // expressList: order?.ordersType === 'mall' ? (order?.expressList as IExpressListInfo[]) : ((order?.expressList as IDeliveryInvoiceInfo[])?.map(getExpressList) as IOrderDeliveryDetail[]),
      expressList: (order?.ordersType === 'mall' ? order?.expressList : order?.expressList?.map((item: any) => {
        return getExpressList(item)
      })) as any,
      invoiced,
      taxpayerId,
      invoiceTitle,
      detail: [],
      itemPrice,
      itemActualPrice,
      itemTotalPrice,
      totalDiscountPrice,
      discountPlanPrice,
      discountItemPrice,
      discountWholePrice,
      discountActivityPrice,
      discountCouponPrice,
      discountItemCouponPrice,
      discountFloorPrice,
      discountIntegralMoneyPrice,
      discountPromoCodeWholePrice: toDecimal(discountPromoCodeWholePrice),
      discountPromoCodeItemPrice: toDecimal(discountPromoCodeItemPrice),
      discountPromoCodePrice: toDecimal(discountPromoCodeWholePrice + discountPromoCodeItemPrice),
      serviceCharge,
      serviceChargeDetailId,
      serviceChargeGratuityName,
      expressPrice,
      expressItem,
      boxPrice,
      thirdOffPrice,
      tax,
      freeTax,
      paidPrice: order.paidFee,
      totalPriceExcludeTip,
      totalPrice,
      totalOriginalPrice,
      tip,
      serviceChargeDescription: '',
      contactAddress,
      contactApt,
      offItems,
      floorOffItem,
      integralMoneyOffItem,
      orderPlanOffItem,
      change,
      isSplit: !!order.parentId,
      isReservation: !!order.yuYue, // ddayjs(order.startTime || '').valueOf() > ddayjs(order.addTime || order.acceptTime || '').valueOf(),
      status,
      serviceChargeDetail,
      isWait,
      taxDetail,
      isMeituanOrEleme,
      isCreditCardFirst,
      scanType,
      posMember,
      surcharge,
      surchargeDetail: surchargeItems
    } as IViewOrder
  }
  static convertDetail (order: IOrder) {
    const viewDetailList: any = []
    const modifierGroupsMap: any = {} // detailId -> modifierGroups
    const modifierGroupMap: any = {} // modifierGroupNo -> modifierGroup
    const refundListMap: {
      [detailId: string]: {
        cnt: number; // 退菜的数量
        price: number; // 退菜的金额
      };
    } = {}
    const boxPriceMap: any = {} // // detailId -> boxPriceMap
    // 先分离制作退菜的map 当前的退菜的cnt已经是合计
    if (order.ordersRefundList) {
      order.ordersRefundList.forEach((ordersRefund: any) => {
        if (ordersRefund.refundType === 'afterpay' || ordersRefund.refundType === 'cancel') {
          return
        }
        ordersRefund.detailList.forEach((detail: any) => {
          if (refundListMap[detail.detailId]) {
            refundListMap[detail.detailId].cnt += detail.cnt
            refundListMap[detail.detailId].price += detail.price
          } else {
            refundListMap[detail.detailId] = {
              cnt: detail.cnt,
              price: detail.originalFee
            }
          }
        })
      })
    }
    // 先行分类主餐品的cnt的map
    const parentCombotMap: any = {}
    const parentComboCntMap: { [detaildId: string]: number } = {}
    const parentProductCntMap: { [detaildId: string]: number } = {}
    order.detailList.forEach((detail: any) => {
      if (detail.itemType === 'product' || detail.itemType === 'mallProduct') {
        const refundCnt = refundListMap[detail.detailId] ? refundListMap[detail.detailId].cnt : 0
        parentProductCntMap[detail.detailId] = detail.cnt + (detail.cnt === 0 ? refundCnt : 0)
      }
      if (detail.itemType === 'FixedCombo' || detail.itemType === 'OptionalCombo') {
        const refundCnt = refundListMap[detail.detailId] ? refundListMap[detail.detailId].cnt : 0
        parentComboCntMap[detail.detailId] = detail.cnt + (detail.cnt === 0 ? refundCnt : 0)
      }
    })
    order.detailList.forEach((detail: any) => {
      if (detail.itemType === 'modifier') {
        const cnt = detail.cnt / parentProductCntMap[detail.parentId]
        const refundCnt = (refundListMap[detail.detailId] ? refundListMap[detail.detailId].cnt : 0) / parentProductCntMap[detail.parentId]
        const originalCnt = cnt === 0 ? cnt + refundCnt : cnt
        const originalPrice = refundListMap[detail.detailId] ? toDecimal((cnt === 0 ? refundListMap[detail.detailId].price : 0) / parentProductCntMap[detail.parentId]) : 0
        let isDefault = false
        try {
          isDefault = JSON.parse(detail.productExt)?.m_def === 1
        } catch (error) {
        }
        const doModifier = {
          no: detail.productNo,
          name: detail.productName,
          detailId: detail.detailId,
          isDefault,
          cnt, // : detail.cnt
          refundCnt,
          originalCnt,
          price: cnt ? toDecimal(detail.originalFee / parentProductCntMap[detail.parentId] / cnt) : 0,
          originalPrice,
          tax: detail.tax
        }
        if (modifierGroupsMap[detail.parentId]) {
          /** 组cnt累加子的cnt */
          // 是否已经存在该组
          if (!modifierGroupMap[detail.parentId]) {
            modifierGroupMap[detail.parentId] = {}
          }
          if (modifierGroupMap[detail.parentId][detail.productGroupNo]) {
            modifierGroupMap[detail.parentId][detail.productGroupNo].cnt += detail.cnt
            modifierGroupMap[detail.parentId][detail.productGroupNo].modifiers.push(doModifier)
          } else {
            modifierGroupMap[detail.parentId][detail.productGroupNo] = {
              no: detail.productGroupNo,
              name: detail.productGroupName,
              selectMin: -1, // not support yet
              selectMax: -1,
              cnt: detail.cnt,
              isReady: true,
              modifiers: [doModifier]
            }
            modifierGroupsMap[detail.parentId].push(modifierGroupMap[detail.parentId][detail.productGroupNo])
          }
        } else {
          modifierGroupMap[detail.parentId] = {}
          modifierGroupMap[detail.parentId][detail.productGroupNo] = {
            no: detail.productGroupNo,
            name: detail.productGroupName,
            selectMin: -1, // not support yet
            selectMax: -1,
            cnt: detail.cnt,
            isReady: true,
            modifiers: [doModifier]
          }
          modifierGroupsMap[detail.parentId] = [modifierGroupMap[detail.parentId][detail.productGroupNo]]
        }
      }
      if (detail.itemType === 'box') {
        boxPriceMap[detail.parentId] = {
          cnt: detail.cnt,
          paidFee: detail.paidFee,
          originalFee: detail.originalFee,
        }
      }
    })

    const picMapNo: any = {};
    (order.pics || [])?.forEach((pic, index) => {
      let { url } = format.toPic(pic)
      let imgArr = []
      try {
        imgArr = JSON.parse(pic || '[]').filter((item: any) => !!item || !!item.url)
      } catch (e) {
        imgArr = [{ url: pic, type: 'product', default: 1, w: null, h: null }]
      }
      const defaultItem = imgArr.filter((item: any) => item.default !== 0)
      let defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : defaultItem[0].url) : url
      const key = order?.picsProduct?.[index]
      const type = defaultItem?.[0]?.type || 'product'

      const pics = defaultImgUrl?.split('.') || []
      if (type === 'product') {
        // not support yet
        const base = pics[pics.length - 2]
        const suffix = pics[pics.length - 1]
        // gif 没有缩略图
        if (['jpg', 'png', 'jpeg'].includes(suffix)) {
          pics[pics.length - 2] = base + '_640'
          defaultImgUrl = pics.join('.')
        }
      }
      key && (picMapNo[key] = defaultImgUrl)
    })
    const deliveryInTime = Number(order?.extList?.find(ext => ext.attrName === 'deliveryInTime')?.attrValue || '0')
    order.detailList.forEach(detail => {
      if (detail.itemType === 'product' || detail.itemType === 'mallProduct') {
        const refundCnt = refundListMap[detail.detailId] ? refundListMap[detail.detailId].cnt : 0
        const originalCnt = detail.cnt + refundCnt
        const refundTotalProductPrice = refundListMap[detail.detailId] ? refundListMap[detail.detailId].price : 0
        const addTimeStamp = ddayjs(detail.addTime).valueOf()
        const startTimeStamp = ddayjs(detail.startTime).valueOf()
        // 对等叫的展示字端，重新做一次计算，抛弃startTime
        const kitchenPrintTimeStamp = ddayjs(detail.kitchenPrintTime).valueOf()
        const preparationTime = detail?.preparationTime || 0
        let startTime = detail.startTime
        // TODO 考虑一下是否需要做差值计算
        const startTimeOffset = detail.startTimeOffset
        const taxCategoryId = detail.taxList && detail.taxList[0] ? detail.taxList[0].productTaxCategoryId : 0
        const unitBoxPrice = boxPriceMap[detail.detailId] ? toDecimal(boxPriceMap[detail.detailId].originalFee / (boxPriceMap[detail.detailId].cnt || 1)) : 0
        const totalBoxPrice = boxPriceMap[detail.detailId] ? toDecimal(boxPriceMap[detail.detailId].originalFee) : 0
        let productExt
        try {
          productExt = detail?.productExt && JSON.parse(detail?.productExt)
        } catch (e) {
        }

        // 自营外卖startTime
        if (addTimeStamp === startTimeStamp && order.eatType === 'delivery') {
          if (productExt?.arriveTime) {
            startTime = productExt.arriveTime
          } else {
            startTime = ddayjs(detail.startTime).add(deliveryInTime + preparationTime, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
        }
        const isAllRefund = !!(refundCnt && refundCnt === originalCnt)
        const totalProductPrice = toDecimal(isAllRefund ? refundTotalProductPrice + detail.originalFee : detail.originalFee)
        const detailInfo = {
          ordersHuangou: !!detail.ordersHuangou,
          yuYue: detail.yuYue,
          pic: picMapNo[detail.productNo] || '',
          type: detail.itemType,
          channel: detail.channel,
          productExt,
          deliveryTime: detail.deliveryTime,
          addTime: detail.addTime,
          productGroupNo: detail.productGroupNo,
          totalProductPrice,
          categoryName: detail.productCategoryName,
          categoryNo: detail.productCategoryNo,
          name: detail.productName,
          productNo: detail.productNo,
          statisticsCategoryNo: detail.productCategoryNo,
          scaleName: detail.productScaleName,
          scaleNo: detail.productScaleNo,
          modifierGroups: modifierGroupsMap[detail.detailId] || [],
          remark: detail.remark,
          isTogo: detail.isTogo,
          pk: detail.pk,
          cnt: detail.cnt,
          refundCnt,
          originalCnt,
          tax: detail.tax,
          showTax: detail.showTax,
          freeTax: detail.freeTax,
          // !!detail.freeTax 当前暂不支持餐品级的免税
          isTaxFree: 0,
          parentId: detail.parentId,
          detailId: detail.detailId,
          addTimeStamp,
          startTime,
          pickTimeRange: detail.pickTimeRange,
          startTimeStamp,
          kitchenPrintTimeStamp,
          startTimeOffset,
          fkey: '', // 暂时未支持
          status: detail.status,
          addUserId: detail.addUserId,
          addUserName: detail.addUserName,
          addUserAvatar: detail.addUserAvatar,
          taxCategoryId,
          unitBoxPrice,
          totalBoxPrice,
          isAddProduct: detail.isAddProduct,
          kitchenPrintTime: detail.kitchenPrintTime,
          currentStatusIndex: detail.currentStatusIndex,
          seat: detail.seat || '',
          addPrice: productExt?.addPirce
        }
        if (parentComboCntMap[detail.parentId] && detail.comboChild) {
          parentCombotMap[detail.parentId] = parentCombotMap[detail.parentId] || {}
          parentCombotMap[detail.parentId][detail.productGroupNo] = parentCombotMap[detail.parentId][detail.productGroupNo] || {
            no: detail.productGroupNo,
            name: detail.productGroupName,
            productNo: detail.productNo,
            selectMin: -1, // not support yet
            selectMax: -1,
            productGroupDetails: []
          }
          parentCombotMap[detail.parentId][detail.productGroupNo].productGroupDetails.push(detailInfo)
        } else {
          viewDetailList.push(detailInfo)
        }
      }
    })
    order.detailList.forEach(detail => {
      if (detail.itemType === 'FixedCombo' || detail.itemType === 'OptionalCombo') {
        const refundCnt = refundListMap[detail.detailId] ? refundListMap[detail.detailId].cnt : 0
        const originalCnt = detail.cnt + refundCnt
        const refundTotalProductPrice = refundListMap[detail.detailId] ? refundListMap[detail.detailId].price : 0
        const addTimeStamp = ddayjs(detail.addTime).valueOf()
        const startTimeStamp = ddayjs(detail.startTime).valueOf()
        // 对等叫的展示字端，重新做一次计算，抛弃startTime
        const kitchenPrintTimeStamp = ddayjs(detail.kitchenPrintTime).valueOf()
        const preparationTime = detail?.preparationTime || 0
        let startTime = detail.startTime
        // TODO 考虑一下是否需要做差值计算
        const startTimeOffset = detail.startTimeOffset
        const taxCategoryId = detail.taxList && detail.taxList[0] ? detail.taxList[0].productTaxCategoryId : 0
        let unitBoxPrice = 0
        let totalBoxPrice = 0
        let addPrice = 0
        const productGroups: any[] = []
        forEach(parentCombotMap[detail.detailId], (group: any) => {
          group.productGroupDetails = group.productGroupDetails.map((product: any) => {
            product.cnt = detail.cnt ? product.cnt / detail.cnt : 0
            unitBoxPrice += boxPriceMap[product.detailId] ? toDecimal(boxPriceMap[product.detailId].originalFee / (boxPriceMap[product.detailId].cnt || 1)) : 0
            totalBoxPrice += boxPriceMap[product.detailId] ? toDecimal(boxPriceMap[product.detailId].originalFee) : 0
            addPrice += toDecimal(product.addPrice || 0)
            return product
          })
          productGroups?.push(group)
        })
        let productExt
        try {
          productExt = detail?.productExt && JSON.parse(detail?.productExt)
        } catch (e) {
        }
        // 自营外卖startTime
        if (addTimeStamp === startTimeStamp && order.eatType === 'delivery') {
          if (productExt?.arriveTime) {
            startTime = ddayjs(productExt.arriveTime, 'client').format('YYYY-MM-DD HH:mm:ss')
          } else {
            startTime = ddayjs(detail.startTime, 'client').add(deliveryInTime + preparationTime, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
          // startTime = ddayjs(detail.startTime, 'client').add(deliveryInTime + preparationTime, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        }
        const isAllRefund = !!(refundCnt && refundCnt === originalCnt)
        const totalProductPrice = toDecimal(isAllRefund ? refundTotalProductPrice + detail.originalFee : detail.originalFee)
        const detailInfo = {
          ordersHuangou: !!detail.ordersHuangou,
          productExt,
          yuYue: detail.yuYue,
          pic: picMapNo[detail.productNo] || '',
          type: detail.itemType,
          addTime: detail.addTime,
          deliveryTime: detail.deliveryTime,
          totalProductPrice,
          categoryName: detail.productCategoryName,
          categoryNo: detail.productCategoryNo,
          name: detail.productName,
          productNo: detail.productNo,
          statisticsCategoryNo: detail.productCategoryNo,
          scaleName: detail.productScaleName,
          scaleNo: detail.productScaleNo,
          modifierGroups: modifierGroupsMap[detail.detailId] || [],
          remark: detail.remark,
          isTogo: detail.isTogo,
          pk: detail.pk,
          cnt: detail.cnt,
          refundCnt,
          originalCnt,
          tax: detail.tax,
          showTax: detail.showTax,
          freeTax: detail.freeTax,
          // !!detail.freeTax 当前暂不支持餐品级的免税
          isTaxFree: 0,
          parentId: detail.parentId,
          detailId: detail.detailId,
          addTimeStamp,
          startTime,
          pickTimeRange: detail.pickTimeRange,
          startTimeStamp,
          kitchenPrintTimeStamp,
          startTimeOffset,
          fkey: '', // 暂时未支持
          status: detail.status,
          addUserId: detail.addUserId,
          addUserName: detail.addUserName,
          addUserAvatar: detail.addUserAvatar,
          taxCategoryId,
          unitBoxPrice,
          totalBoxPrice,
          isAddProduct: detail.isAddProduct,
          kitchenPrintTime: detail.kitchenPrintTime,
          currentStatusIndex: detail.currentStatusIndex,
          productGroups,
          seat: detail.seat || '',
          addPrice,
        }
        viewDetailList.push(detailInfo)
      }
    })
    const itemMktList: any[] = []
    // 因为某些优惠涉及到加料，并且该加料的优惠单独记录，但是在输出时有要合并到餐品级，则需要同时建立加料的列表
    const modifierMktList: any[] = []
    // 店长折扣平摊下面的计入到平摊的优惠中
    const managerDiscountMap: { [detailId: string]: any } = {}
    // 单品折扣记录一下
    const singleDiscountMap: { [detailId: string]: any } = {}
    // 整单优惠
    if (order.discountList) {
      order.discountList.forEach((discount) => {
        if (discount.discountType === 'managerDiscount') {
          // 整单折扣优惠整理
          managerDiscountMap[discount.detailId] = discount.fee
          // discount.activityType === 'activity' &&
        } else if (discount.pk) {
          // 单品折扣整理
          itemMktList.push(discount)
        } else if (discount.detailId) {
          // 口味
          modifierMktList.push(discount)
        }
        if (discount.detailId) {
          singleDiscountMap[discount.detailId] = (singleDiscountMap[discount.detailId] || 0) + discount.fee
        }
      })
    }
    const pk2Mkt = itemMktList.length ? groupBy(itemMktList, 'pk') : {}
    const modifierDetailId2Mkt = modifierMktList.length ? groupBy(modifierMktList, 'detailId') : {}
    const modifierPk2Mkt: any = {}
    return computedViewDetailList(orderBy(viewDetailList, (item: any) => parseInt(item?.seat || '0')), managerDiscountMap, modifierDetailId2Mkt, modifierPk2Mkt, pk2Mkt, order.channel, singleDiscountMap)
  }
  static virtualDetail (order: any) {
    let viewDetailList: any = []
    let surcharge: number = 0
    /** 活动类型 */
    let activityType: any = null
    const parentProductMap: { [detaildId: string]: any } = {}
    forEach(order.detailList, (detailItem: any) => {
      if (detailItem.itemType === 'surcharge') {
        surcharge += detailItem.paidFee
      }
      if (order.eatType === 'redeemCouponByMoney' && detailItem.productCategoryNo && detailItem.productCategoryNo !== order.eatType) {
        activityType = detailItem.productCategoryNo
      }
      if (detailItem.parentId === '0') {
        parentProductMap[detailItem.detailId] = detailItem
      }
    })
    if (order.eatType === 'redeemCouponByMoney' && activityType) {
      forEach(order.detailList, (detailItem: any) => {
        if (detailItem.parentId) {
          try {
            parentProductMap[detailItem.parentId].activityType = activityType
            if (!parentProductMap[detailItem.parentId]?.coupons) {
              parentProductMap[detailItem.parentId].coupons = []
            }
            parentProductMap[detailItem.parentId]?.coupons?.push({
              productName: detailItem.productName,
              coupons: JSON.parse(detailItem.productExt || '[]')
            })
          } catch (error) {
          }
        }
      })
      viewDetailList = map(parentProductMap, item => {
        const paidFee = toDecimal(item.paidFee - surcharge)
        return {
          ...item,
          totalPrice: paidFee,
          name: item.productName,
        }
      })
    } else {
      order.details?.forEach((detail: any) => {
        const paidFee = toDecimal(detail.paidFee - surcharge)
        const detailInfo: any = {
          cnt: 1,
          name: detail.productName,
          totalPrice: paidFee,
          ...detail,
          paidFee
        }
        if (order.eatType === 'redeemCouponByMoney') {
          detailInfo.cnt = order.detailList?.[0]?.cnt || 1
          detailInfo.coupons = detail.coupons || []
        } else {
          detailInfo.cardNo = detail.cardNo
          detailInfo.desc = this.getCardInfo(detail)
        }
        viewDetailList.push(detailInfo)
      })
    }
    return viewDetailList
  }
  static getCardInfo (data: any) {
    let maxcouponCnt = 0
    if (data.coupons?.length) {
      data.coupons.forEach((item: { couponCnt: number }) => {
        maxcouponCnt += item.couponCnt
      })
    }

    if (data.expireTimeChangeUnit) {
      if (data.expireTimeChangeUnit === 'day') {
        return i18n.t('mkt.member.days', { number: data.expireTimeChangeValue })
      } else if (data.expireTimeChangeUnit === 'month') {
        let type = 'month'
        data.expireTimeChangeValue === 3 ? type = 'season' : data.expireTimeChangeValue === 6 ? type = 'halfYear' : type = 'month'
        return i18n.t(`mkt.record.${type}`)
      } else {
        return i18n.t(`mkt.record.${data.expireTimeChangeUnit}`)
      }
    } else {
      return `${i18n.t('mkt.record.charge', { price: format.toPrice(data.balanceRechargeChange) })} ${data.balanceGiveChange ? (',' + i18n.t('mkt.record.send', { price: format.toPrice(data.balanceGiveChange) })) : ''} ${data.coupons ? (',' + i18n.t('mkt.record.sendCoupon', { num: maxcouponCnt })) : ''}`
    }
  }
}

export default OrderFactory
